import type { TagJSONObject, TagSummaryJSONObject } from '@ikegps/core-api';
import { CheckBox, type CheckBoxState } from '../../components/input/input.checkbox';
import { addStyles } from '../../components/theme';
import { m } from '../../mithril';
import { TagState } from '../../page/tag.state';
import { CurrentState } from '../../state/page.state';
import { TagIcon } from '../tag.icon/tag.icon';
import { CSS, Style } from './tag.card.checkbox.style';

addStyles(Style);

export const TagCardCheckbox = {
	view(
		state: TagState,
		selectedState: CheckBoxState,
		tag: TagJSONObject,
		tagSummary?: TagSummaryJSONObject,
		color?: string,
		showRedDot?: boolean
	) {
		const hasSelections = CurrentState.Tag.tagSize > 0;

		const className = `${CSS.container} ${hasSelections ? CSS.hasSelections : ''}`;
		return m('div', { className }, [
			hasSelections ? null : TagIcon.view(tag, tagSummary, color, showRedDot),
			CheckBox.view(selectedState),
		]);
	},
};
